"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ReactHTMLPicture = _interopRequireDefault(require("@micado-digital/react-htmlpicture/ReactHTMLPicture"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _FallbackImage = _interopRequireDefault(require("@micado-digital/react-ui/components/FallbackImage"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _CartContext = _interopRequireDefault(require("../../../context/CartContext"));
var _MessageContext = _interopRequireDefault(require("../../../context/MessageContext"));
var _deleteItem = _interopRequireWildcard(require("../../../utils/cart/deleteItem"));
var _updateItem = _interopRequireWildcard(require("../../../utils/cart/updateItem"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Availability = _interopRequireDefault(require("../../Availability"));
var _Price = _interopRequireDefault(require("../../Price"));
var _Quantity = _interopRequireDefault(require("../../Quantity"));
var _CartItem = _interopRequireDefault(require("./CartItem.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CartItem = _ref => {
  let {
    attributes: _attributes = [],
    available,
    availableCount,
    guid,
    isEditable = true,
    lang,
    maxQuantity,
    media,
    price,
    quantity,
    title,
    type
  } = _ref;
  const {
    amount,
    originalAmount
  } = price || {};
  const {
    setCart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    setMessageObj
  } = (0, _react.useContext)(_MessageContext.default);
  const css = (0, _CartItem.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const handleDelete = async () => {
    const response = await (0, _deleteItem.default)({
      cartItemGUID: guid
    });
    const {
      msg
    } = response || {};
    if (msg) {
      setMessageObj({
        message: l("reactShop.messages.errors.".concat(_deleteItem.DELETE_ITEM_ERRORS[msg])),
        type: "error"
      });
      return;
    }
    localStorage.setItem("mco-shop-cart", JSON.stringify(response));
    setCart(response);
    setMessageObj({
      message: l("reactShop.messages.success.CART_ITEM_DELETED"),
      type: "success"
    });
  };
  const handleUpdate = async value => {
    const response = await (0, _updateItem.default)({
      cartItemGUID: guid,
      quantity: value
    });
    const {
      msg
    } = response || {};
    if (msg) {
      setMessageObj({
        message: l("reactShop.messages.errors.".concat(_updateItem.UPDATE_ITEM_ERRORS[msg])),
        type: "error"
      });
      return;
    }
    localStorage.setItem("mco-shop-cart", JSON.stringify(response));
    setCart(response);
    setMessageObj({
      message: l("reactShop.messages.success.CART_UPDATED"),
      type: "success"
    });
  };
  const attributes = (0, _react.useMemo)(() => {
    var _attributes$map;
    return _attributes === null || _attributes === void 0 || (_attributes$map = _attributes.map(_ref2 => {
      let {
        title,
        value
      } = _ref2;
      return "<span>".concat(title, "</span>: ").concat(value);
    })) === null || _attributes$map === void 0 ? void 0 : _attributes$map.join(", ");
  }, [_attributes]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.cartItem, {
      "mco-shop-cart-item--is-disabled": !isEditable
    }, "mco-shop-cart-item")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.image, "mco-shop-cart-item__image")
  }, !(0, _isEmpty.default)(media) ? /*#__PURE__*/_react.default.createElement(_ReactHTMLPicture.default, {
    media: media,
    mediaFormats: {
      xs: "product-teaser"
    }
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.fallbackImage, "mco-shop-cart-item__fallback-image")
  }, /*#__PURE__*/_react.default.createElement(_FallbackImage.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "mco-shop-cart-item__content")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.details, "mco-shop-cart-item__details")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.title, "mco-shop-cart-item__title"),
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), attributes && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.attributes, "mco-shop-cart-item__attributes"),
    dangerouslySetInnerHTML: {
      __html: attributes
    }
  }), isEditable ? /*#__PURE__*/_react.default.createElement(_Availability.default, {
    isAvailable: available,
    count: availableCount,
    lang: lang
  }) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.quantityLabel, "mco-shop-cart-item__quantity-label")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.cart.labels.quantity",
    l: l
  }), ": ", quantity), type === "digital" && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.shippingLabel, "mco-shop-cart-item__shipping-label"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.cart.labels.shippingPerMail",
    l: l
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.wrapper, "mco-shop-cart-item__wrapper")
  }, type !== "voucher" && isEditable && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.quantity, "mco-shop-cart-item__quantity")
  }, /*#__PURE__*/_react.default.createElement(_Quantity.default, {
    max: maxQuantity,
    value: quantity,
    onChange: handleUpdate
  })), /*#__PURE__*/_react.default.createElement(_Price.default, {
    classNames: (0, _clsx.default)(css.price, "mco-shop-cart-item__price"),
    amount: amount,
    lang: "de",
    originalAmount: originalAmount,
    showTaxLabel: false
  })), isEditable && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: (0, _clsx.default)(css.deleteButton, "mco-shop-cart-item__delete-button"),
    onClick: handleDelete
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: "/img/icons/shop/delete.svg",
    size: 24
  }))));
};
var _default = exports.default = CartItem;